module.exports = __webpack_public_path__ + "img/precioVerde.54d40588.svg";